export const TEMPLATE_API = '/api/d/template';

export const TEMPLATE_ID_API = `${TEMPLATE_API}/{id}`;

export const TEMPLATE_TYPE_QUERY_PARAM = 'type';

export const TEMPLATE_NAME_QUERY_PARAM = 'name';
